import { render, staticRenderFns } from "./ArchiveUploadsModal.vue?vue&type=template&id=1c902c9c"
import script from "./ArchiveUploadsModal.vue?vue&type=script&lang=js"
export * from "./ArchiveUploadsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports